import {searchLocation} from "@/http/services/http-services-route";
import autocomplete from "autocompleter";
import {goToLocationByAddressID} from "@/helpers/ol/ol-route-helper";
import {goToCoordinate} from "@/helpers/ol/ol-coordinate-helper";
import {
    applyFilter,
    clearActiveFilter,
    getActiveFilter,
    getFilterByKey,
    setActiveFilter
} from "@/helpers/filter/filter-helper";
import {getWfsByColumn} from "@/helpers/ol/ol-http-helper";
import {getBySelector} from "@/helpers/element-helper";
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper.js";

export function initAutoComplete(input) {

    input.value = ''

    autocomplete({
        input: input,
        showOnFocus: true,
        debounceWaitMs: 200,
        fetch: function(text, update) {

            if(window.activeAdressSearchType === undefined || window.activeAdressSearchType === "2") {
                return
            }
            text = text.toLowerCase();

            const suggestions = []
            searchLocation(text, window.activeAdressSearchType).then(locations => {
                locations.suggestions.map(location => {
                    const suggestion = {}
                    suggestion.label = location.value
                    suggestion.value = location.data.id
                    suggestions.push(suggestion)
                })
                update(suggestions);
            })
        },
        onSelect: function(item) {
            input.value = item.label;

            window.locationByAdressValue = item.value
            goToLocationByAddressID(item.value)
        }
    });
}

export function clickAutoComplete() {

    const value = getBySelector('#iptHomeFindAddress').value
    switch (parseInt(window.activeAdressSearchType)) {
        case 0:
            const selected = document.querySelector('.autocomplete .selected')

            if(selected) {
                selected.click()
            }
            break;
        case 1:
            goToLocationByAddressID(value)
            break;
        case 2:
            goToCoordinate(value)
            break;
        default:
            const dataset = document.querySelector('.liHomeFindAdressType.active').dataset
            const filterKey = dataset.filterKey
            const filter = getFilterByKey(filterKey)
            const formAttribute = filter.form.form_attributes.find(formAttribute => formAttribute.ID === parseInt(dataset.formAttributeId))
            const formAttributeKey = filter.form.form_attributes.findIndex(formAttribute => formAttribute.ID === parseInt(dataset.formAttributeId))
            const column = formAttribute.attribute.Attribute

            console.log(formAttribute)

            if(formAttribute.ShowResultSearchBarInTable) {
                const activeFilter = getActiveFilter()

                if(!activeFilter || (activeFilter.BookmarkPresentationID !== filter.BookmarkPresentationID)) {
                    setActiveFilter(filter.BookmarkPresentationID, filter.PresentationID, formAttribute.FormID)
                }

                console.log('settt')
                const element = getBySelector(`layer-info-filter-settings-item[data-key="${formAttributeKey}"] input`)
                element.value = value
                updateFilterBadge(element, value)


                applyFilter()
            } else {
                clearActiveFilter()

                let layerMenuItem = document.querySelector(`layer-menu-group-item[data-id="${filter.BookmarkPresentationID}"]`)
                if(layerMenuItem) {
                    layerMenuItem = layerMenuItem.querySelector('input')
                    if(!layerMenuItem.checked) {
                        layerMenuItem.click()
                    }
                }
                getWfsByColumn(filter.DomainID, filter.PresentationID, value, column)
            }
            break;
    }
}
